import React, { useState, useEffect, useMemo } from "react";
import DataTable from "react-data-table-component";
import { TextField } from "@mui/material";
import { dataTableCustomStyles } from "../../ListPage";

const RMSProperties = (props) => {
  const [tableData, setTableData] = useState([]);
  const [filterText, setFilterText] = useState("");

  useEffect(() => {
    if (props.data) {
      setTableData(props.data);
    }
  }, [props.data]);

  let columns = [
    {
      name: "ID",
      selector: "id",
      sortable: true,
    },
    {
      name: "Name",
      selector: "name",
      sortable: true,
    },
  ];

  const handleFilterText = (event) => {
    setFilterText(event.target.value);
  };

  const filteredItems = tableData.filter(
    (item) =>
      item.name && item.name.toLowerCase().includes(filterText.toLowerCase())
  );

  const subHeaderComponentMemo = useMemo(() => {
    return (
      <div className="subHeader">
        <div className="subHeaderText">
          {props.selectedRow && (
            <h5 className="subHeaderTextContent">
              {props.selectedRow.name} Selected
            </h5>
          )}
        </div>
        <TextField
          id="filter-text"
          onChange={handleFilterText}
          label="Search"
          variant="outlined"
          size="small"
        />
      </div>
    );
  }, [filterText, props.selectedRow]);

  return (
    <div>
      <DataTable
        selectableRows
        selectableRowsNoSelectAll={true}
        selectableRowDisabled={(row) => {
          return props.disabled;
        }}
        onSelectedRowsChange={props.onSelectedRowsChange}
        selectableRowSelected={(row) => {
          if (props.selectedRow) {
            return props.selectedRow.id == row.id;
          } else {
            return false;
          }
        }}
        columns={columns}
        data={filteredItems}
        pagination
        paginationPerPage={5}
        paginationRowsPerPageOptions={[5]}
        noHeader={true}
        subHeader
        subHeaderComponent={subHeaderComponentMemo}
        customStyles={dataTableCustomStyles}
      />
    </div>
  );
};

export default RMSProperties;
